import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { get, omit } from 'lodash'
import { AutoComplete } from 'redux-form-material-ui'
import { loadAttributeValues, unloadAttributeValues } from '../../actions'

class AttributeAutoComplete extends PureComponent {
  componentDidMount() {
    this.props.loadAttributeValues(this.props.attributo)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.attributo !== nextProps.attributo) {
      this.props.unloadAttributeValues(this.props.attributo)
      this.props.loadAttributeValues(nextProps.attributo)
    }
  }

  componentWillUnmount() {
    this.props.unloadAttributeValues(this.props.attributo)
  }

  render() {
    const { attributo, values, loadingValues, ...passProps } = this.props

    return (
      <AutoComplete
        {...omit(passProps, ['loadAttributeValues', 'unloadAttributeValues'])}
        disabled={loadingValues}
        dataSource={values}
      />
    )
  }
}

const emptyList = []
const mapStateToProps = (state, ownProps) => {
  const piece = `attributeValues.${ownProps.attributo}`
  return {
    values: get(state, `${piece}.values`, emptyList),
    loadingValues: get(state, `${piece}.loading`, true),
  }
}

export default connect(mapStateToProps, {
  loadAttributeValues,
  unloadAttributeValues,
})(AttributeAutoComplete)



// WEBPACK FOOTER //
// ./src/common/AddItemForm/AttributeAutoComplete.js